import { takeEvery, put, call, all, fork } from 'redux-saga/effects';
import envDetect from '@tcc/env-detect';
import { shouldUseMocks } from '../utils/mocks';
import { queryParam } from '../utils/queryString';
import {
  FeatureFlagResponse,
  receiveLegacyFeatures,
  RequestFeaturesAction,
} from '../actions/featureActions';
import { requestFeature } from '../requesters/featureRequester';
import { REQUEST_FEATURES } from '../constants/actionTypes';

export function* getFeatures(action: RequestFeaturesAction) {
  const { flagNames } = action;

  if (!envDetect.isEC2()) {
    const declinedFeatures = queryParam('declinedFeatures');
    const declinedFeaturesArr =
      shouldUseMocks() && declinedFeatures ? declinedFeatures.split(',') : [];

    const flagValues: FeatureFlagResponse[] = flagNames.map((flagName) =>
      declinedFeaturesArr.includes(flagName)
        ? {
            value: false,
          }
        : {
            value: true,
            'source-key': 'internal-users',
          }
    );
    return yield put(receiveLegacyFeatures(flagNames, flagValues));
  }

  try {
    const responses: FeatureFlagResponse[] = yield all(
      flagNames.map((flagName) => call(requestFeature, flagName))
    );

    return yield put(receiveLegacyFeatures(flagNames, responses));
  } catch (error) {
    return yield put(receiveLegacyFeatures([], []));
  }
}

export function* getFeaturesWatcher() {
  yield takeEvery(REQUEST_FEATURES, getFeatures);
}

export default function* rootSaga() {
  yield fork(getFeaturesWatcher);
}
